import axios from "axios";
import { useState, useEffect } from "react";

export default function MemberPage() {
    const [members, setMembers] = useState([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [targetId, setTargetId] = useState(null);

    useEffect(() => {
        axios.get('/api/manage/users', {timeout: process.env.REACT_APP_API_TIMEOUT})
            .then((res) => {
                setMembers(res.data);
            })
            .catch((err) => {
                console.error('유저 불러오기 실패: ', err.message);
            });
    }, []);

    // members 날짜로 정렬
    useEffect(() => {
        [...members].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )
    }, [members]);

    const handleConfirm = (e) => {
        e.stopPropagation();
        setMembers(members.filter((m) => m.memberId !== targetId));
        setShowConfirm(false);
        setTargetId(null);
    };

    const handleCancel = () => {
        setShowConfirm(false);
        setTargetId(null);
    };

    return (
        <div style={{ maxWidth: '100%', height: 'fit-contents', margin: "40px 10px", fontFamily: "sans-serif", position: "relative"}}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>유저 리스트</h2>
            <table style={{
                width: "100%",
                borderCollapse: "collapse",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>ID</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>이름</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>계정 타입</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>휴대전화</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>계정 생성일</th>
                    </tr>
                </thead>
                <tbody>
                    {members.map((member, idx) => (
                        <tr key={member.id} onClick={() => window.location.href = '/users/'+member.id} style={{ background: idx % 2 ? "#fafbfc" : "#fff", cursor: "pointer" }}>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{member.id}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{member.name}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{member.type === 0 ? '일반 유저': '멤버십 유저'}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{member.phone}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{new Date(member.createdAt).toLocaleDateString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showConfirm && (
                <div style={{
                    position: "fixed",
                    top: 0, left: 0, width: "100vw", height: "100vh",
                    background: "rgba(0,0,0,0.25)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "#fff",
                        borderRadius: 8,
                        padding: "32px 24px",
                        boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
                        minWidth: 320,
                        textAlign: "center"
                    }}>
                        <div style={{ fontSize: 18, marginBottom: 24 }}>정말 삭제하시겠습니까?</div>
                        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
                            <button
                                style={{
                                    background: "#ff4d4f",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "8px 24px",
                                    fontWeight: 600,
                                    cursor: "pointer"
                                }}
                                onClick={handleConfirm}
                            >
                                삭제
                            </button>
                            <button
                                style={{
                                    background: "#f0f0f0",
                                    color: "#222",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "8px 24px",
                                    fontWeight: 600,
                                    cursor: "pointer"
                                }}
                                onClick={handleCancel}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}